import * as actionTypes from "./../../Constants/locations/locationActionTypes";

export function doShowLoader (showLoader = false ) {
    return{
        type: actionTypes.SHOW_LOADER,
        payload: { showLoader }
    }
}

export function showLoader(shouldShowLoader) {
    return dispatch => {
        return dispatch(doShowLoader(shouldShowLoader));
    };
}